import { render, staticRenderFns } from "./people.vue?vue&type=template&id=c2486c5a&scoped=true&"
import script from "./people.vue?vue&type=script&lang=js&"
export * from "./people.vue?vue&type=script&lang=js&"
import style0 from "./people.vue?vue&type=style&index=0&id=c2486c5a&lang=scss&scoped=true&"
import style1 from "./people.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2486c5a",
  null
  
)

export default component.exports